export enum MedicalFeeState {
    controled = 1,
    noFee = 2,
    preFee = 3,
    Fee = 4,
    FeeCanceled = 5,
    down = 7,
    noControled = 8
}
